<template>
  <div class="theme-heading">
    <div class="theme-heading__avatar">
      <img src="/static/img/avatar/study.png" loading="lazy" alt="зоозавр"/>
    </div>
    <div class="theme-heading__bullet">Тема 3</div>
    <h1 class="theme-heading__title">Питание</h1>
    <p class="theme-heading__text">Что важно знать?</p>
  </div>

  <div class="topic">
    <div class="theme-point"><span class="theme-point__number">1</span>
      <h2 class="theme-point__title">Питание щенка</h2>
      <div class="theme-point__img">
        <picture>
          <source srcset="/static/img/theme-3/dog-1.webp" type="image/webp">
          <img src="/static/img/theme-3/dog-1.png" alt="Питание щенка"/>
        </picture>
      </div>
      <p class="theme-point__text">Щенков
        <span class="accent">до&nbsp;6&nbsp;месяцев</span>
        рекомендуется
        <span class="accent">кормить трижды в&nbsp;день</span>.
        <span class="accent">Взрослых собак</span> обычно кормят
        <span class="accent">два раза в&nbsp;день</span>.
        Щенки до&nbsp;6&nbsp;месяцев нуждаются в&nbsp;дрессировке&nbsp;&mdash;
        <span class="accent">в&nbsp;качестве поощрения</span> можно использовать
        <span class="accent">гранулы привычного корма</span>, &laquo;вычитая&raquo; при этом некоторую их&nbsp;чаcть из&nbsp;суточной нормы кормления.</p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">Не&nbsp;следует предоставлять собакам свободный доступ к&nbsp;корму: соблюдайте нормы кормления, чтобы не&nbsp;допустить развития избыточного веса.</p>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">2</span>
      <h2 class="theme-point__title">РЕЖИМ КОРМЛЕНИЯ</h2>
      <div class="theme-point__img">
        <picture>
          <source srcset="/static/img/theme-3/dog-2.webp" type="image/webp">
          <img src="/static/img/theme-3/dog-2.png" alt="РЕЖИМ КОРМЛЕНИЯ">
        </picture>
      </div>
      <p class="theme-point__text">Собаки любят следовать привычному распорядку, поэтому лучше предлагать им&nbsp;корм в&nbsp;одно и&nbsp;то&nbsp;же время и&nbsp;в&nbsp;одном и&nbsp;том&nbsp;же месте.</p>
      <p class="theme-point__text"><span class="accent">Корм домашнего приготовления редко может быть полностью сбалансированным и&nbsp;полноценным.</span></p>
      <div class="theme-point__ordered">
        <ol class="theme-point__ordered-list">
          <li class="theme-point__ordered-item"><span class="paw">
                      <svg class="icon-paw">
                        <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
                      </svg></span>
            <div>
              <h3 class="title">ЗНАЕТЕ ЛИ ВЫ?</h3>
              <p class="text">Чтобы составить полноценный рацион для собаки, нужно включить в&nbsp;него не&nbsp;менее <span class="accent">50&nbsp;питательных веществ</span>. Это значит, что в&nbsp;домашних условиях очень сложно приготовить полностью сбалансированный корм. При этом производители профессиональных кормов учитывают особые потребности собак и&nbsp;могут обеспечить их&nbsp;хорошо сбалансированным питанием.</p>
            </div>
          </li>
        </ol>
      </div>
      <div class="theme-point__slider-block hide-desktop">
        <h3 class="theme-point__slider-title">Для щенков</h3>
        <div class="swiper theme-point__slider" data-theme-point-slider>
          <div class="swiper-wrapper">
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-3/dog-slider-1-1.webp" type="image/webp">
                <img src="/static/img/theme-3/dog-slider-1-1.png" alt="">
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-3/dog-slider-1-2.webp" type="image/webp">
                <img src="/static/img/theme-3/dog-slider-1-2.png" alt="">
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-3/dog-slider-1-3.webp" type="image/webp">
                <img src="/static/img/theme-3/dog-slider-1-3.png" alt="">
              </picture>
            </div>
          </div>
          <div class="theme-point__pagination swiper-pagination" data-theme-point-slider-pagination></div>
        </div>
        <span class="theme-point__slider-text">Листайте карусель</span>
      </div>
      <div class="theme-point__slider-block hide-desktop">
        <h3 class="theme-point__slider-title">Для взрослых собак</h3>
        <div class="swiper theme-point__slider" data-theme-point-slider>
          <div class="swiper-wrapper">
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-3/dog-slider-2-1.webp" type="image/webp">
                <img src="/static/img/theme-3/dog-slider-2-1.png" alt="">
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-3/dog-slider-2-2.webp" type="image/webp">
                <img src="/static/img/theme-3/dog-slider-2-2.png" alt="">
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-3/dog-slider-2-3.webp" type="image/webp">
                <img src="/static/img/theme-3/dog-slider-2-3.png" alt="">
              </picture>
            </div>
          </div>
          <div class="theme-point__pagination swiper-pagination" data-theme-point-slider-pagination></div>
        </div>
        <span class="theme-point__slider-text">Листайте карусель</span>
      </div>
      <div class="theme-point-tabs">
        <button
          class="theme-point-tabs__btn"
          data-tab-button="puppy"
          data-tab-button-state="active"
          @click="sendEventYM('diet_step3_click_btn', {'diet_step3_click_btn_param': 'Для щенков'})"
        >Для щенков</button>
        <button
          class="theme-point-tabs__btn"
          data-tab-button="dog"
          @click="sendEventYM('diet_step3_click_btn', {'diet_step3_click_btn_param': 'Для взрослых собак'})"
        >Для взрослых собак</button>
      </div>
      <div class="theme-point-panels">
        <div class="theme-point-panels__panel" data-tab-panel="puppy" data-tab-panel-state="active">
          <div class="swiper theme-point__slider" data-theme-point-slider>
            <div class="swiper-wrapper">
              <div class="swiper-slide theme-point__slide">
                <picture>
                  <source srcset="/static/img/theme-3/dog-slider-1-1.webp" type="image/webp">
                  <img src="/static/img/theme-3/dog-slider-1-1.png" alt="">
                </picture>
              </div>
              <div class="swiper-slide theme-point__slide">
                <picture>
                  <source srcset="/static/img/theme-3/dog-slider-1-2.webp" type="image/webp">
                  <img src="/static/img/theme-3/dog-slider-1-2.png" alt="">
                </picture>
              </div>
              <div class="swiper-slide theme-point__slide">
                <picture>
                  <source srcset="/static/img/theme-3/dog-slider-1-3.webp" type="image/webp">
                  <img src="/static/img/theme-3/dog-slider-1-3.png" alt="">
                </picture>
              </div>
            </div>
            <div class="theme-point__pagination swiper-pagination" data-theme-point-slider-pagination></div>
          </div>
          <span class="theme-point__slider-text">Листайте карусель</span>
        </div>
        <div class="theme-point-panels__panel" data-tab-panel="dog">
          <div class="swiper theme-point__slider" data-theme-point-slider>
            <div class="swiper-wrapper">
              <div class="swiper-slide theme-point__slide">
                <picture>
                  <source srcset="/static/img/theme-3/dog-slider-2-1.webp" type="image/webp">
                  <img src="/static/img/theme-3/dog-slider-2-1.png" alt="">
                </picture>
              </div>
              <div class="swiper-slide theme-point__slide">
                <picture>
                  <source srcset="/static/img/theme-3/dog-slider-2-2.webp" type="image/webp">
                  <img src="/static/img/theme-3/dog-slider-2-2.png" alt="">
                </picture>
              </div>
              <div class="swiper-slide theme-point__slide">
                <picture>
                  <source srcset="/static/img/theme-3/dog-slider-2-3.webp" type="image/webp">
                  <img src="/static/img/theme-3/dog-slider-2-3.png" alt="">
                </picture>
              </div>
            </div>
            <div class="theme-point__pagination swiper-pagination" data-theme-point-slider-pagination></div>
          </div>
          <span class="theme-point__slider-text">Листайте карусель</span>
        </div>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">3</span>
      <h2 class="theme-point__title">Когда следует подумать об&nbsp;изменении рациона собаки?</h2>
      <div class="theme-point__slider-block">
        <div class="swiper theme-point__slider" data-theme-point-slider="data-theme-point-slider">
          <div class="swiper-wrapper">
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-3/dog-slider-3-1.webp" type="image/webp">
                <img src="/static/img/theme-3/dog-slider-3-1.jpg" alt=""/>
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-3/dog-slider-3-2.webp" type="image/webp">
                <img src="/static/img/theme-3/dog-slider-3-2.jpg" alt=""/>
              </picture>
            </div>
          </div>
          <div class="theme-point__pagination swiper-pagination" data-theme-point-slider-pagination="data-theme-point-slider-pagination"></div>
        </div>
        <span class="theme-point__slider-text">Листайте карусель</span>
      </div>
      <p class="theme-point__text">Может наступить время, когда собаке потребуется изменение рациона.</p>
      <div class="theme-point__numbered">
        <div class="theme-point__numbered-title">4&nbsp;причины поменять рацион</div>
        <ul class="theme-point__numbered-list">
          <li class="theme-point__numbered-item"><span class="number">1</span>
            <div>
              <p class="text">Переход собаки с&nbsp;одного из&nbsp;трех ключевых этапов жизни на&nbsp;другой: щенок, взрослая собака и&nbsp;собака зрелого возраста.</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">2</span>
            <div>
              <p class="text">Ваша собака беременна.</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">3</span>
            <div>
              <p class="text">Заболевание или состояние, при котором собака нуждается в&nbsp;дополнительном поддерживающем питании.</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">4</span>
            <div>
              <p class="text">Вы&nbsp;изучили различные рационы для собак или посоветовались с&nbsp;ветеринарным врачом и&nbsp;приняли решение сменить корм вашего питомца.</p>
            </div>
          </li>
        </ul>
      </div>
      <p class="theme-point__text">Рекомендуется <span class="accent">постепенный перевод</span> собаки на&nbsp;новый рацион <span class="accent">как минимум в&nbsp;течение недели</span>. Это позволит избежать расстройства желудка, неофобии и&nbsp;прочих стрессов.</p>
      <div class="theme-point__ordered desktop-grow">
        <ol class="theme-point__ordered-list">
          <li class="theme-point__ordered-item">
            <span class="paw">
              <svg class="icon-paw">
                <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
              </svg>
            </span>
            <div>
              <p class="text"><span class="accent">Дни 1&nbsp;и&nbsp;2&nbsp;</span> — 75&nbsp;% прежнего корма + 25&nbsp;% нового корма</p>
            </div>
          </li>
          <li class="theme-point__ordered-item">
            <span class="paw">
              <svg class="icon-paw">
                <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
              </svg>
            </span>
            <div>
              <p class="text"><span class="accent">Дни 3&nbsp;и&nbsp;4&nbsp;</span> — 50&nbsp;% прежнего корма + 50&nbsp;% нового корма</p>
            </div>
          </li>
          <li class="theme-point__ordered-item">
            <span class="paw">
              <svg class="icon-paw">
                <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
              </svg>
            </span>
            <div>
              <p class="text"><span class="accent">Дни 5&nbsp;и&nbsp;6&nbsp;</span> — 25&nbsp;% прежнего корма + 75&nbsp;% нового корма</p>
            </div>
          </li>
          <li class="theme-point__ordered-item">
            <span class="paw">
              <svg class="icon-paw">
                <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
              </svg>
            </span>
            <div>
              <p class="text"><span class="accent">День 7</span> — 100&nbsp;% нового корма</p>
            </div>
          </li>
        </ol>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">4</span>
      <h2 class="theme-point__title">Собака должна регулярно пить воду</h2>
      <div class="theme-point__img">
        <picture>
          <source srcset="/static/img/theme-3/dog-4.webp" type="image/webp">
          <img src="/static/img/theme-3/dog-4.png" alt="Собака должна регулярно пить воду"/>
        </picture>
      </div>
      <p class="theme-point__text">Поставьте миску с&nbsp;водой рядом с&nbsp;кормом, чтобы собака могла пить воду, когда захочет.</p>
      <div class="theme-point__ordered">
        <ol class="theme-point__ordered-list">
          <li class="theme-point__ordered-item">
            <span class="paw">
              <svg class="icon-paw">
                <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
              </svg>
            </span>
            <div>
              <h3 class="title">ЗНАЕТЕ ЛИ&nbsp;ВЫ?</h3>
              <p class="text"><span class="accent">Молока следует избегать</span>, потому что собаки не&nbsp;могут его как следует переваривать.</p>
            </div>
          </li>
        </ol>
      </div>
    </div>
  </div>

  <div class="topic__img">
    <img src="/static/img/zoozavr.png" loading="lazy" alt="зоозавр"/>
  </div>

  <button class="btn topic__btn"
  @click="$emit('goToQuiz'); sendEventYM('quiz3_click_btn')"
  >Закрепить знания</button>
</template>

<script>
import { onMounted, onBeforeUnmount } from 'vue'
import { SliderManager } from '@/assets/js/script.js'
import analyticsTracking from '@/mixins/analyticsTracking.js'
import 'swiper/css'
import 'swiper/css/pagination'

export default {
  name: 'LessonDogsTopic3',
  mixins: [analyticsTracking],
  emits: ['goToQuiz'],
  setup() {
    let sliderManager = null

    onMounted(() => {
      sliderManager = new SliderManager()
      sliderManager.init()
    })

    onBeforeUnmount(() => {
      if (sliderManager) {
        sliderManager.destroy()
        sliderManager = null
      }
    })

    return {}
  }
}
</script>

<style scoped>
</style>
